import { KPI_GROUPS_FAILURE, KPI_GROUPS_REQUEST, KPI_GROUPS_SUCCESS } from '../groups/actionTypes';
import {
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
  FETCH_GROUP_REQUEST,
  FETCH_GROUP_SUCCESS,
  FETCH_GROUP_FAILURE,
  UPDATE_GROUPS_REQUEST,
  UPDATE_GROUPS_FAILURE,
  UPDATE_GROUPS_SUCCESS,
  DELETE_GROUPS_REQUEST,
  DELETE_GROUPS_FAILURE,
  DELETE_GROUPS_SUCCESS,
  CLEAR_GROUP_ERRORS,    // Nouvelles imports
  CLEAR_GROUP_SUCCESS,
} from './actionTypes';

const initialState = {
  groups: [],
  group: null,
  loadingGroup: false,
  errorGroup: null,
  groupsKpi : null,
  groupAdded: null
};

const Groups = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GROUPS_REQUEST:
      return {
        ...state,
        loadingGroup: true,
        errorGroup: null,
        groupAdded: false
      };
    case FETCH_GROUPS_SUCCESS:
      return {
        ...state,
        loadingGroup: false,
        groups: action.payload,
      };
    case FETCH_GROUPS_FAILURE:
      return {
        ...state,
        loadingGroup: false,
        errorGroup: action.payload,
      };
    case FETCH_GROUP_REQUEST:
      return {
        ...state,
        loadingGroup: true,
        errorGroup: null,
        groupAdded: false
      };
    case FETCH_GROUP_SUCCESS:
      return {
        ...state,
        loadingGroup: false,
        group: action.payload.data,
      };
    case FETCH_GROUP_FAILURE:
      return {
        ...state,
        loadingGroup: false,
        errorGroup: action.payload,
      };
    case UPDATE_GROUPS_REQUEST:
      return {
        ...state,
        loadingGroup: true,
        errorGroup: null,
        groupAdded: false
      };
    case UPDATE_GROUPS_SUCCESS:
      return {
        ...state,
        loadingGroup: false,
        group: null,
        groupAdded: true
      };
    case UPDATE_GROUPS_FAILURE:
      return {
        ...state,
        loadingGroup: false,
        errorGroup: action.payload,
      };
    case DELETE_GROUPS_REQUEST:
      return {
        ...state,
        loadingGroup: true,
        errorGroup: null,
        groupAdded: false
      };
    case DELETE_GROUPS_SUCCESS:
      return {
        ...state,
        groupAdded: true,
        loadingGroup: false,
        groups: state.groups.filter(group => group.id !== action.payload),
      };
    case DELETE_GROUPS_FAILURE:
      return {
        ...state,
        loadingGroup: false,
        errorGroup: action.payload,
      };
    case KPI_GROUPS_REQUEST:
      return {
        ...state,
        loadingGroup: true,
        errorGroup: null,
        groupAdded: false
      };
    case KPI_GROUPS_SUCCESS:
      return {
        ...state,
        loadingGroup: false,
        groupsKpi: action.payload,
      };
    case KPI_GROUPS_FAILURE:
      return {
        ...state,
        loadingGroup: false,
        errorGroup: action.payload,
      };
    case CLEAR_GROUP_ERRORS:
      return {
        ...state,
        errorGroup: null,
      };
    case CLEAR_GROUP_SUCCESS:
      return {
        ...state,
        groupAdded: null,
        groupsKpi: null, // On peut aussi réinitialiser les KPI si nécessaire
      };
      
    default:
      return state;
  }
};

export default Groups;